import gql from "graphql-tag"

export const SUBSCRIBE_ALL_PRODUCTS_WITH_PRICES = gql`
    subscription {
        Products(order_by: {sequence: asc_nulls_last}){
            id
            displayName
            bunchKg
            noOfPieceInBox
            image
            colorCode
            weight
            packageType
            containerType
            ProductPrices{
                id
                price
                unitId
                priceListId
            }
        }
    }`
